import { persistLocationState, readPersistedLocationState } from '../infra/locationStatePersistence';
import { uploadFileToCloudStorage } from '../infra/utils';
import { actualDownloadCsv } from '../utils/csv.utils';
import { injectScriptOrLink } from './adapters/scriptInjector';
const toHex = (bytes)=>Array.from(bytes, (b)=>b.toString(16).padStart(2, '0')).join('');
export const makeBecameVisibleRegistrar = (doc)=>(onBecameVisible)=>{
        const handleVisibilityChange = ()=>doc.visibilityState === 'visible' && onBecameVisible();
        doc.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>doc.removeEventListener('visibilitychange', handleVisibilityChange);
    };
export const makePageRestoredRegistrar = (win)=>(onPageRestored)=>{
        const handlePageShow = (event)=>event.persisted && onPageRestored();
        win.addEventListener('pageshow', handlePageShow);
        return ()=>win.removeEventListener('pageshow', handlePageShow);
    };
export const makeBrowserIo = (host, wiring)=>({
        locationReload: wiring.locationReload,
        registerBecameVisibleListener: makeBecameVisibleRegistrar(host.doc),
        registerPageRestoredListener: makePageRestoredRegistrar(host.pageShowWin),
        changeLocation: wiring.changeLocation,
        getOrigin: ()=>host.win.location.origin,
        copyToClipboard: (text)=>host.nav.clipboard.writeText(text),
        openNewTab: wiring.openNewTab,
        downloadCsv: actualDownloadCsv,
        injectScriptOrLink,
        uploadFileToCloudStorage,
        scrollIntoView: function scrollIntoView(element) {
            let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return element.scrollIntoView && element.scrollIntoView({
                behavior: options.disableScrollAnimation ? 'instant' : 'smooth',
                block: options.block || 'center'
            });
        },
        getBoundingClientRect: (element)=>element.getBoundingClientRect(),
        afterNextPaint: (callback)=>host.win.requestAnimationFrame(()=>host.win.requestAnimationFrame(()=>callback())),
        getViewport: ()=>({
                width: host.win.innerWidth,
                height: host.win.innerHeight
            }),
        prefersReducedMotion: ()=>host.win.matchMedia('(prefers-reduced-motion: reduce)').matches,
        scrubUrlFragment: ()=>host.win.history.replaceState(null, '', host.win.location.pathname + host.win.location.search),
        createObjectUrl: (file)=>host.url.createObjectURL(file),
        getPathname: ()=>host.win.location.pathname,
        readPersistedLocationState: ()=>readPersistedLocationState(wiring.historyIo),
        persistLocationState: (patch)=>persistLocationState(wiring.historyIo, patch),
        crypto: {
            randomNonce: ()=>toHex(host.win.crypto.getRandomValues(new Uint8Array(32))),
            sha256Hex: async (input)=>{
                const digest = await host.win.crypto.subtle.digest('SHA-256', host.encodeUtf8(input));
                return toHex(new Uint8Array(digest));
            }
        },
        webAppleAuth: wiring.webAppleAuth
    });
